import { get, post } from '../axios'

// 创建活动card
export function ams_admin_card_create_post(map, option) {
  return post(
    `${process.env.VUE_APP_AMS_ADMIN}/ams-admin/card/create`,
    map,
    option
  ).then(response => response)
}

// 根据id查询活动card
export function ams_admin_card_get_id_get(map, option) {
  return get(
    `${process.env.VUE_APP_AMS_ADMIN}/ams-admin/card/get/${map.id}`,
    map,
    option
  ).then(response => response)
}

// 查询活动规则信息
export function ams_admin_card_activity_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_AMS_ADMIN}/ams-admin/card/activity/list`,
    map,
    option
  ).then(response => response)
}

// 编辑活动card
export function ams_admin_card_modify_post(map, option) {
  return post(
    `${process.env.VUE_APP_AMS_ADMIN}/ams-admin/card/modify`,
    map,
    option
  ).then(response => response)
}

// 根据id删除活动card
export function ams_admin_card_delete_id_get(map, option) {
  return get(
    `${process.env.VUE_APP_AMS_ADMIN}/ams-admin/card/delete/${map.id}`,
    map,
    option
  ).then(response => response)
}

// 查询活动card信息
export function ams_admin_card_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_AMS_ADMIN}/ams-admin/card/list`,
    map,
    option
  ).then(response => response)
}

// 调整活动顺序
export function ams_admin_card_sequence_id1_id2_get(map, option) {
  return get(
    `${process.env.VUE_APP_AMS_ADMIN}/ams-admin/card/sequence/${map.id1}/${map.id2}`,
    map,
    option
  ).then(response => response)
}
